import { checkId, checkName } from '../../../../constants/form';
import badWords from './badWords';
import { FRIENDS } from '../../../../constants/shared/states/names';
import { RESET, SEND } from './actions';
import { FOR_ID, FOR_NAME } from './modalTypes';

export default {
  modalForName: {
    wishType: FOR_NAME,
    title: 'wishContent.modalName.title',
    input: {
      type: 'text',
      badWordText: 'wishContent.modalName.input.badWordText',
      notAvailableSymbolsText: 'wishContent.modalName.input.hasNotAvailableSymbol',
      placeholder: 'wishContent.modalName.input.placeholder',
      autoFocus: false,
      autoComplete: '',
      name: 'name',
      rules: checkName,
    },
    buttons: [
      {
        text: 'wishContent.modalName.buttons.0.text',
        className: 'custom-button wish-modal__button',
      },
      {
        type: 'button',
        modalData: { action: 'close', data: { type: 'current' } },
        text: 'wishContent.modalName.buttons.1.text',
        className: 'custom-button_gray wish-modal__button',
      },
    ],
  },
  buttons: [
    {
      disposable: true,
      icon: 'wish/repeat',
      callbackKey: RESET,
      className: 'custom-button_nav custom-button_transparent wish__content-soc-button',
    },
    {
      timeout: 3000,
      icon: 'wish/accept',
      callbackKey: SEND,
      className: 'custom-button_nav custom-button_transparent wish__content-soc-button',
    },
  ],
  extraProfileModal: {
    title: 'wishContent.extraProfileModal.title',
    buttons: [
      {
        disposable: true,
        text: 'wishContent.extraProfileModal.buttons.0.text',
        className: 'custom-button wish-gift-card__button',
        callbackKey: 'sendWish',
      },
      {
        disposable: true,
        text: 'wishContent.extraProfileModal.buttons.1.text',
        className: 'custom-button_gray wish-gift-card__button',
        modalData: { action: 'close', data: { type: 'current' } },
      },
    ],
  },
  modalForId: {
    wishType: FOR_ID,
    title: 'friends.postcard.modalId.title',
    input: {
      type: 'number',
      min: 0,
      placeholder: 'friends.postcard.modalId.input.placeholder',
      autoFocus: false,
      autoComplete: '',
      name: 'id',
      rules: checkId,
    },
    buttons: [
      {
        text: 'friends.postcard.modalId.buttons.0.text',
        timeout: 3000,
        className: 'custom-button wish-modal__button',
      },
      {
        type: 'button',
        modalData: { action: 'close', data: { type: 'current' } },
        text: 'friends.postcard.modalId.buttons.1.text',
        className: 'custom-button_gray wish-modal__button',
      },
    ],
  },
  closeButton: {
    icon: 'wish/close',
    redirect: FRIENDS,
    className: 'custom-button_nav custom-button_transparent wish__content-close',
  },
  navigation: [
    {
      id: 'prev',
      className: `custom-button_transparent custom-button_nav wish__content-nav`,
    },
    {
      id: 'next',
      className: `custom-button_transparent custom-button_nav wis__content-nav`,
    },
  ],
  badWords: badWords,
};
